export enum CalendarType {
  Outlook = 'outlook',
  Google = 'google',
  ICS = 'ics',
}
